import React from 'react'
import Select from '@cloudscape-design/components-themed/select'

// https://cloudscape.design/components/select
export function RadSelect ({ filteringAriaLabel, ...rest }) {
  return (
    <Select
      {...rest}
      filteringAriaLabel={filteringAriaLabel ?? rest.filteringType != null ? 'search' : null}
    />
  )
}
